"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaBlockMetadata1ToJSON = exports.RosettaBlockMetadata1FromJSONTyped = exports.RosettaBlockMetadata1FromJSON = void 0;
function RosettaBlockMetadata1FromJSON(json) {
    return RosettaBlockMetadata1FromJSONTyped(json, false);
}
exports.RosettaBlockMetadata1FromJSON = RosettaBlockMetadata1FromJSON;
function RosettaBlockMetadata1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'transactions_root': json['transactions_root'],
        'difficulty': json['difficulty'],
    };
}
exports.RosettaBlockMetadata1FromJSONTyped = RosettaBlockMetadata1FromJSONTyped;
function RosettaBlockMetadata1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'transactions_root': value.transactions_root,
        'difficulty': value.difficulty,
    };
}
exports.RosettaBlockMetadata1ToJSON = RosettaBlockMetadata1ToJSON;
//# sourceMappingURL=RosettaBlockMetadata1.js.map